import { useEffect, useState } from 'react';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

import { List } from '../domain';
import { useUserKey } from './useUserKey';

const ENDPOINT = '/users/profiles/removeUserFromList';

type UnsubscribeFromListRequest = { emailListId: number; userKey: string };

export const useUnsubscribeFromList = () => {
  const [fromList, unsubscribe] = useState<List>();
  const userKey = useUserKey(true);
  const { mutate, isLoading, isSuccess, isError, reset } = useRestMutation<
    unknown,
    UnsubscribeFromListRequest
  >(ENDPOINT);

  useEffect(() => {
    if (fromList?.id) {
      mutate({ emailListId: fromList.id, userKey });
    }
  }, [fromList?.id, mutate, userKey]);

  return { unsubscribe, isLoading, isSuccess, isError, fromList, reset };
};
